import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const ABOUT_IMG = "/work2.jpg";

export const About = () => {
  const { t } = useLanguage();
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-36 max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-7"
        >
          <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="about-overline">
            {t.about.overline}
          </p>
          <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl lg:text-6xl" data-testid="about-title">
            {t.about.title}
          </h2>
          <p className="mt-8 text-slate-300 text-base md:text-lg leading-relaxed" data-testid="about-body">
            {t.about.body}
          </p>
          <p className="mt-5 text-slate-400 text-base leading-relaxed">{t.about.body2}</p>
          <ul className="mt-8 space-y-3">
            {t.about.points.map((p, i) => (
              <li key={i} className="flex items-center gap-3 text-slate-200" data-testid={`about-point-${i}`}>
                <CheckCircle2 size={18} className="text-[#2563EB] shrink-0" />
                <span className="text-sm md:text-base">{p}</span>
              </li>
            ))}
          </ul>
          <div
            data-testid="about-owner-card"
            className="mt-10 flex items-center gap-5 rounded-2xl border border-white/10 bg-[#0F172A]/60 p-5 max-w-md"
          >
            <img
              src="/owner.jpg"
              alt={t.contact.owner}
              className="w-20 h-20 rounded-full object-cover border-2 border-[#2563EB]"
            />
            <div>
              <p className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#60A5FA] mb-1">
                {t.about.ownerLabel}
              </p>
              <p className="font-display font-bold text-xl text-white">{t.contact.owner}</p>
              <p className="text-slate-400 text-sm">{t.contact.role}</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="lg:col-span-5 lg:mt-24"
        >
          <div className="relative overflow-hidden rounded-2xl border border-white/10 group">
            <img
              src={ABOUT_IMG}
              alt="Commercial jetliner"
              className="w-full aspect-[4/5] object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/80 to-transparent" />
            <div className="absolute bottom-5 left-5 font-mono-tech text-xs tracking-widest text-slate-300 uppercase">
              LAJA AIR TECH SERVICES LLC
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
